export default {
  batch: null,
  loading: false,
}
